
<template>
    <div class="loadingg">
        <div class="inn ">
            <div class="loader ">
            <div class="self-building-square-spinner">
                <div class="square spinner-square-first"></div>
                <div class="square spinner-square-second"></div>
                <div class="square spinner-square-third"></div>
                <div class="square clear spinner-square-fourth"></div>
                <div class="square spinner-square-fifth"></div>
                <div class="square spinner-square-sixth"></div>
                <div class="square clear spinner-square-seventh"></div>
                <div class="square spinner-square-eighth"></div>
                <div class="square spinner-square-nineth"></div>
            </div>
        </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: "ProgressBar",
};
</script>
<style>
x,
.loader {
    justify-content: center;
    align-items: center;
    width: 100%;
}

.loader {
    display: flex;
    min-height: inherit;
    max-height: inherit;
    height: inherit;
}

.self-building-square-spinner {
    top: 12.5px;
    height: 75px;
    width: 75px;
}

.self-building-square-spinner,
.self-building-square-spinner * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.self-building-square-spinner {
    top: 12.5px;
    height: 75px;
    width: 75px;
}

.self-building-square-spinner .square:first-child {
    background-color: #0082e1 !important;
}

.self-building-square-spinner .square {
    height: 18.75px;
    width: 18.75px;
    top: -12.5px;
    margin-right: 6.25px;
    margin-top: 6.25px;
    float: left;
    position: relative;
    opacity: 0;
    -webkit-animation: self-building-square-spinner 6s infinite;
    animation: self-building-square-spinner 6s infinite;
    animation-duration: 1.5s;
}

.self-building-square-spinner .square:nth-child(2) {
    background-color: #17b4d5 !important;
}

.self-building-square-spinner .square:nth-child(3) {
    background-color: #d3e526 !important;
}

.self-building-square-spinner .square:nth-child(4) {
    background-color: #009b00 !important;
}

.self-building-square-spinner .square:nth-child(5) {
    background-color: #bb2437 !important;
}

.self-building-square-spinner .square:nth-child(6) {
    background-color: #dc007d !important;
}

.self-building-square-spinner .square:nth-child(7) {
    background-color: #ff6400 !important;
}

.self-building-square-spinner .square:nth-child(8) {
    background-color: gold !important;
}

.self-building-square-spinner .square:last-child {
    background-color: #0082e1 !important;
}

.spinner-square-first {
    background-color: #0082e1 !important;
    -webkit-animation-delay: 1s;
    animation-delay: .45s !important;
}

.spinner-square-second {
    background-color: #17b4d5 !important;
    -webkit-animation-delay: 1.3s;
    animation-delay: 525ms !important;
}

.spinner-square-third {
    background-color: #d3e526 !important;
    -webkit-animation-delay: 1.6s;
    animation-delay: .6s !important;
}

.spinner-square-fourth {
    background-color: #009b00 !important;
    -webkit-animation-delay: .3s;
    animation-delay: 225ms !important;
}

.spinner-square-fifth {
    background-color: #bb2437 !important;
    -webkit-animation-delay: .6s;
    animation-delay: .3s !important;
}

.spinner-square-sixth {
    background-color: #dc007d !important;
    -webkit-animation-delay: .9s;
    animation-delay: 375ms !important;
}

.spinner-square-seventh {
    background-color: #ff6400 !important;
    -webkit-animation-delay: 1s;
    animation-delay: 0ms !important;
}

.spinner-square-eighth {
    background-color: gold !important;
    -webkit-animation-delay: .2s;
    animation-delay: 75ms !important;
}

.spinner-square-nineth {
    background-color: #0082e1 !important;
    -webkit-animation-delay: .3s;
    animation-delay: .15s !important;
}


.self-building-square-spinner .clear {
    clear: both;
}

.self-building-square-spinner,
.self-building-square-spinner * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

Pseudo *,
:after,
:before {
    box-sizing: border-box;
}

*,
:after,
:before {
    box-sizing: border-box;
}

@keyframes self-building-square-spinner {
    0% {
        opacity: 0;
    }

    5% {
        opacity: 1;
        top: 0;
    }

    50.9% {
        opacity: 1;
        top: 0;
    }

    55.9% {
        opacity: 0;
        top: inherit;
    }
}
</style>